import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import JSONWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import TSWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';
import MySQLWorker from 'monaco-sql-languages/esm/languages/mysql/mysql.worker?worker';
import { LanguageIdEnum } from 'monaco-sql-languages';
import 'monaco-sql-languages/esm/languages/pgsql/pgsql.contribution';
import PGSQLWorker from 'monaco-sql-languages/esm/languages/pgsql/pgsql.worker?worker';

/** define MonacoEnvironment.getWorker  */
(globalThis as any).MonacoEnvironment = {
    getWorker(_: any, label: string) {
        if (label === LanguageIdEnum.PG) {
            return new PGSQLWorker();
        }
        if (label === 'mysql') {
            return new MySQLWorker();
        }
        if (label === 'json') {
            return new JSONWorker();
        }
        if (label === 'typescript' || label === 'javascript') {
            return new TSWorker();
        }
        return new EditorWorker();
    }
};

loader.config({ monaco });

loader.init();
